import React from 'react'

import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

export const Wrapper: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
}

export const TitleStyle: React.CSSProperties = {
  ...sharedStyles.subheading,
}

export const MainIcon: React.CSSProperties = {
  width: toPx(sharedStyles.IconSizes.LARGE),
  height: toPx(sharedStyles.IconSizes.LARGE),
  marginRight: toPx(sharedStyles.Spacings.BLOCK_VERTICAL_SPACING),
  flexShrink: 0,
}
